// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React, { useEffect, useState } from "react";
import { Menu } from "antd";
import { Link } from "@reach/router";
import { useTranslation } from "react-i18next";
import {
  HomeOutlined,
  ReadOutlined,
  AlignLeftOutlined,
  SettingOutlined,
  PieChartOutlined,
  UserOutlined,
  BarChartOutlined,
  UnorderedListOutlined,
  BookOutlined,
  KeyOutlined,
  UsergroupAddOutlined,
  UserDeleteOutlined
} from "@ant-design/icons";
import { AuthentifiedUser } from "../../api/backend-openapi";
import { useStore } from "effector-react";
import { authentifiedUserStore } from "../../state/auth/AuthStore";
import { NboAction } from "../types/AuthTypes";

const SideMenu: React.FC<{}> = () => {
  const { t } = useTranslation();
  const [selectedKey, setSelectedKey] = useState("home");

  const authentifiedUser: AuthentifiedUser | null = useStore(
    authentifiedUserStore
  );
  const menu = [
    { key: "home", link: "/", icon: <HomeOutlined />, text: t("menu.home") },
    {
      key: "newsThemes",
      link: "/newsThemes",
      icon: <AlignLeftOutlined />,
      text: t("menu.themes"),
      feature: "nboNewsTheme"
    },
    {
      key: "news",
      link: "/news",
      icon: <ReadOutlined />,
      text: t("menu.news"),
      feature: "nboNews"
    },
    {
      key: "surveys",
      link: "/surveys",
      icon: <PieChartOutlined />,
      text: t("menu.surveys"),
      feature: "nboSurvey"
    },
    {
      key: "keywords",
      link: "/keywords",
      icon: <KeyOutlined />,
      text: t("menu.keywords"),
      feature: "nboKeyword"
    },
    {
      key: "thematicDossiers",
      link: "/thematicDossiers",
      icon: <BookOutlined />,
      text: t("menu.thematicDossiers"),
      feature: "nboThematicDossier"
    },
    {
      key: "userManagement",
      link: "/users",
      icon: <UserOutlined />,
      text: t("menu.users"),
      feature: "nboUserManagement"
    },
    {
      key: "profiles",
      link: "/profiles",
      icon: <UsergroupAddOutlined />,
      text: t("menu.profiles"),
      feature: "nboUserManagement"
    },
    {
      key: "broadcastLists",
      link: "/broadcastLists",
      icon: <UnorderedListOutlined />,
      text: t("menu.broadcast"),
      feature: "nboBroadcastList"
    },
    {
      key: "missingUsers",
      link: "/missingUsers",
      icon: <UserDeleteOutlined />,
      text: t("menu.missingUsers"),
      feature: "nboMissingUser"
    },
    {
      key: "settings",
      link: "/settings",
      icon: <SettingOutlined />,
      text: t("menu.settings"),
      feature: "nboSetting"
    }
  ];
  if (
    (authentifiedUser?.branch && authentifiedUser.branch.includes("crcc")) ||
    !authentifiedUser?.branch
  ) {
    menu.push({
      key: "statistics",
      link: "/statistics",
      icon: <BarChartOutlined />,
      text: t("menu.statistics"),
      feature: "nboStatistics"
    });
  }

  useEffect(() => {
    const currentItem = menu.find(
      item => window.location.pathname.split("/")[1] === item.link.split("/")[1]
    );
    if (currentItem) setSelectedKey(currentItem.key);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname, menu]);

  return (
    <>
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[selectedKey]}
        style={{ height: "200px", width: "225px" }}
      >
        {authentifiedUser &&
          authentifiedUser.rights &&
          menu.map(item => {
            /* eslint-disable */
            // @ts-ignore
            const appearItem = authentifiedUser.rights[item.feature]?.includes(
              NboAction.nboRead
            );
            /* eslint-enable */
            return appearItem || item.key === "home" ? (
              <Menu.Item key={item.key}>
                <Link to={item.link}>
                  {item.icon} {item.text}
                </Link>
              </Menu.Item>
            ) : null;
          })}
      </Menu>
    </>
  );
};

export default SideMenu;
